import { HStack, Stack, Text } from "@chakra-ui/react";
import { KeyboardHint } from "../../../../shared/views/KeyboardHint/KeyboardHint";
import { observer } from "mobx-react";
import { useStores } from "../../../../shared/stores/RootStore";
import { MapMode } from "../../../../project/stores/MapStore";

const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

const ctrlKey = isMac ? "⌘" : "Ctrl";
const leftKey = <>&#8592;</>;
const rightKey = <>&#8594;</>;
const shiftKey = "⇧";

const ShortcutListBase = () => {
  const { osaNodeStore, hlaStore, mapStore } = useStores();
  const selecedNode = !!osaNodeStore.selectedId;

  const showMultiSelection =
    !!hlaStore.selectedId ||
    mapStore.mode === MapMode.CraCoding ||
    mapStore.mode === MapMode.ManageNodes;

  return (
    <Stack fontSize="sm">
      {showMultiSelection && (
        <HStack>
          <KeyboardHint
            keys={[shiftKey, <Text fontSize={"xs"}>click</Text>]}
            label="or"
          />
          <KeyboardHint
            keys={[shiftKey, <Text fontSize={"xs"}>drag</Text>]}
            label={`to toggle multi selection`}
          />
        </HStack>
      )}
      {selecedNode && (
        <>
          <KeyboardHint keys={[leftKey]} label={`to go to the previous node`} />
          <KeyboardHint keys={[rightKey]} label={`to go to the next node`} />
          <KeyboardHint
            keys={[ctrlKey, leftKey]}
            label={`to go to the first node`}
          />
          <KeyboardHint
            keys={[ctrlKey, rightKey]}
            label={`to go to the last node`}
          />
        </>
      )}
    </Stack>
  );
};

export const ShortcutList = observer(ShortcutListBase);
